import type { FC, ReactElement } from "react";

import { BulkGridSelectionModeEnum } from "@ryde/shared";

import { bulkGridSelectionModeIconMap } from "./bulk-grid-selection-mode-icon.constants";

interface IBulkGridSelectionModeGlyphProps {
  mode: BulkGridSelectionModeEnum;
  className?: string;
}

export const BulkGridSelectionModeGlyph: FC<
  IBulkGridSelectionModeGlyphProps
> = ({ mode, className = "select-all-icon" }): ReactElement => {
  const Icon = bulkGridSelectionModeIconMap[mode];

  return <Icon className={className} fontSize="inherit" />;
};
